// Material Dashboard 2 React layouts
import Dashboard from "layouts/dashboard";
import Tables from "layouts/tables";
import Billing from "layouts/billing";
import RTL from "layouts/rtl";
import Notifications from "layouts/notifications";
import Profile from "layouts/profile";
import SignIn from "./layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";
import CNoteTracking from "layouts/cNoteTracking/CNoteTracking";
import MisReport from "layouts/misReport/MisReport";
import PODDOWNLOADS from "layouts/podDownloads/PodDownload";
import SERVICABLEPINCODES from "layouts/ServicablePincode/ServiceablePincodes";
import COMPLAINTS from "layouts/Complaints/Complaints";
import Icon from "@mui/material/Icon";
import ProtectedRoute from "ProtectedRoute";
import Login from "layouts/authentication/sign-in/index";
import PickupRequest from "layouts/pickupRequest/PickupRequest";
import PickupReport from "layouts/pickupReport/PickupReport";
import ChangePassword from "layouts/changePassword/ChangePassword";

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <ProtectedRoute element={<Dashboard />} />,
  },
  {
    type: "collapse",
    name: "MIS Report",
    key: "mis-report",
    icon: <Icon fontSize="small">bar_chart</Icon>,
    route: "/Customer/mis-report",
    component: <ProtectedRoute element={<MisReport />} />,
  },
  {
    type: "collapse",
    name: "Pickup Request",
    key: "pickup-request",
    icon: <Icon fontSize="small">local_shipping</Icon>,
    route: "/Customer/pickup-request",
    component: <ProtectedRoute element={<PickupRequest />} />,
  },
  {
    type: "collapse",
    name: "Pickup Report",
    key: "pickup-report",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/Customer/pickup-report",
    component: <ProtectedRoute element={<PickupReport />} />,
  },
  {
    type: "collapse",
    name: "CNote Tracking",
    key: "cnote-tracking",
    icon: <Icon fontSize="small">explore</Icon>,
    route: "/Customer/cnote-tracking",
    component: <ProtectedRoute element={<CNoteTracking />} />,
  },
  {
    type: "collapse",
    name: "Pod Downloads",
    key: "pod-downloads",
    icon: <Icon fontSize="small">cloud_download</Icon>,
    route: "/Customer/pod-downloads",
    component: <ProtectedRoute element={<PODDOWNLOADS />} />,
  },
  {
    type: "collapse",
    name: "Servicable Pincodes",
    key: "servicable-pincodes",
    icon: <Icon fontSize="small">location_on</Icon>,
    route: "/Customer/servicable-pincodes",
    component: <ProtectedRoute element={<SERVICABLEPINCODES />} />,
  },
  {
    type: "collapse",
    name: "Complaints",
    key: "customer-complaints",
    icon: <Icon fontSize="small">chat</Icon>,
    route: "/Customer/complaints",
    component: <ProtectedRoute element={<COMPLAINTS />} />,
  },
  {
    type: "collapse",
    name: "Change Password",
    key: "change-password",
    icon: <Icon fontSize="small">lock</Icon>,
    route: "/Customer/change-password",
    component: <ProtectedRoute element={<ChangePassword />} />,
  },
  {
    index: true,
    route: "/Customer/login",
    component: <Login onLogin={(status) => {}} />,
  },
];

export default routes;
